import React from "react";

import shopifyLogo from "@assets/shopify-logo.png";
import { ConnectionType } from "@north-beam/nb-client-side";
import { ConnectionCard } from "@pages/settings/connection-card";
import { type CardProps2 } from "@pages/settings/core";
import { PrimaryButton } from "@shared/buttons";

const type = ConnectionType.integration_shopify;

export function ShopifyConnectionCard(props: CardProps2) {
  const renderChild = () => {
    return () => <ShopifyLoginComponent />;
  };

  const successfulConnectionExtraText = (
    <>
      <p className="card-text">
        <em>
          Note: To connect another shopify account, log into your other shopify
          account, go to apps.shopify.com/north-beam, and install the app
        </em>
      </p>
    </>
  );

  return (
    <ConnectionCard
      type={type}
      connectionTypeName="Shopify"
      connectionCallToAction={`
        Integrate your Shopify account to start receiving insights about
        sales and LTV.
      `}
      successfulConnectionExtraText={() => successfulConnectionExtraText}
      logoUrl={shopifyLogo}
      logoAltText="Shopify Logo"
      knowledgeBaseLink="https://docs.northbeam.io/docs/shopify-order-sync"
    >
      {renderChild()}
    </ConnectionCard>
  );
}

function ShopifyLoginComponent() {
  const SHOPIFY_DEV_INSTALL_LINK =
    "https://partners.shopify.com/1189787/apps/3609999/test";
  const SHOPIFY_PROD_STORE_LINK = "https://apps.shopify.com/north-beam";

  const getShopifyInstallLink = () => {
    const isLocalDev = process.env.REACT_APP_NB_ENV === "dev-local";
    if (isLocalDev) {
      return SHOPIFY_DEV_INSTALL_LINK;
    } else {
      return SHOPIFY_PROD_STORE_LINK;
    }
  };

  return (
    <div>
      <p>
        Please login to your Shopify account and download the Northbeam app from
        the Shopify app store:
        <div className="mt-4">
          <a href={getShopifyInstallLink()}>
            <PrimaryButton>CONNECT</PrimaryButton>
          </a>
        </div>
      </p>
    </div>
  );
}
